/**
 * @author vishwadeep.kapoor
 */

import endPoints from '../../config/endPoints';

export const DEFAULT_ACTION = 'zaggle/HomePage/DEFAULT_ACTION';
export const FETCH_HOME_DATA = 'zaggle/HomePage/FETCH_HOME_DATA';
export const FETCH_HOME_DATA_ERROR = 'zaggle/HomePage/FETCH_HOME_DATA_ERROR';
export const FETCH_HOME_DATA_SUCCESS = 'zaggle/HomePage/FETCH_HOME_DATA_SUCCESS';
/**
 * @inheritDoc /client/containers/RestaurantDeals/index.js
 */
export const DEFAULT_PRE_PAYLOAD = { tag_types: JSON.stringify(['Popular Restaurants']) };
export const DEFAULT_WEB_CONSTANT = { web: true };

export const BANNER_MOBILE = [
  {
    key: 1,
    link: 'https://www.1mg.com/',
    image: endPoints.ONEMG_BANNER_MOBILE,
    isExternal: true,
  },
  {
    key: 2,
    link: '',
    image: endPoints.MOBIKWIK_BANNER_MOBILE,
    isExternal: false,
  },
];

export const BANNER_DESKTOP = [
  {
    key: 1,
    link: 'https://www.1mg.com/',
    image: endPoints.ONEMG_BANNER_DESKTOP,
    isExternal: true,
  },
  {
    key: 2,
    link: '',
    image: endPoints.MOBIKWIK_BANNER_DESKTOP,
    isExternal: false,
  },
];

export const CLIENT_BANNERS_DESKTOP_MANIPAL = [
  {
    key: 0,
    link: '',
    image: endPoints.Mani1,
  },
];

// export const RestaurantCard = [
//   {
//     image: require('./../../assets/images/rest-1.jpg'),
//     offers: 'Flat 20% OFF',
//     type: 'restaurant-deal',
//     key: 1,
//   },
//   {
//     offers: '1+1 on Drinks',
//     type: 'restaurant-deal',
//     key: 2,
//   },
//   {
//     offers: 'FREE Drinks',
//     type: 'restaurant-deal',
//     key: 3,
//   },
//   {
//     offers: 'Flat 10% OFF',
//     type: 'restaurant-deal',
//     key: 4,
//   },
//   {
//     offers: '2+1 Offers',
//     type: 'restaurant-deal',
//     key: 5,
//   },
//   {
//     offers: 'FREE Drinks',
//     type: 'restaurant-deal',
//     key: 6,
//   },
//   {
//     image: require('./../../assets/images/rest-2.jpg'),
//     offers: 'Flat 20% OFF',
//     type: 'restaurant-deal',
//     key: 7,
//   },
// ];

export const MAKE_VIDEO_THUMBNAIL_URL = (youtubeVideos) => {
  const result = youtubeVideos;
  const returnWithImageBase = [];
  if (result.data) {
    result.data.forEach((element) => {
      const _element = element;
      const url = new URL(element.video).pathname;
      const str = url ? url.split('/embed/')[1] : '';
      // element.thumbnail = '';
      // element.thumbnail = `https://img.youtube.com/vi/${str}/sddefault.jpg`;
      _element.thumbnail = `https://img.youtube.com/vi/${str}/hqdefault.jpg`;
      returnWithImageBase.push(_element);
    });
    result.data = returnWithImageBase;
  }
  return result.data;
};



// WEBPACK FOOTER //
// client/containers/HomePage/constants.js